import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const shareDetailsMatchingTemplate = htmlE`<div class="py-2 text-sm">
    <p><span data-i18n-key="selectShareAccountWithTypeLike" data-i18n-opt='{"type": "${"title"}"}'>${"titleText"}</span><span>:</span></p>
    <textarea id="select_matching_items_value" rows="5" class="w-full mt-3">${"value"}</textarea>
    <div class="mt-3">
        <input type="checkbox" id="exact_match" name="exact_match">
        <label for="exact_match">
            <span data-i18n-key="exactMatch">${"exactMatchText"}</span>?
        </label>
    </div>
</div>`;
